<template>
  <b-container class="page">
    <b-row>

      <b-col class="container-box-elements" cols="12" md="6">
        <div class="main-title">
          <div class="main-title-2"></div>
          <div class="main-title-3">
            Noleggio
          </div>
        </div>
        <div class="quote">
          <p>Sciare è un'emozione. Noleggiarsi l'attrezzatura giusta è il primo passo per viverla
            al meglio.<br>
            Che tu stia mettendo gli sci ai piedi per la prima volta o che tu sia un habitué delle piste
            nere, l'attrezzatura che hai fa tutta la differenza. Troppo pesante, troppo rigida,
            troppo usurata: la scelta sbagliata può rovinarti una giornata intera — o peggio, farti venire
            voglia di non tornare. Da Due Elle Sport ci prendiamo cura di ogni dettaglio perché questo
            non accada mai.</p>
        </div>
        <b-button variant="outline-primary"
                  href="/files/contrattoNoleggio.pdf"
                  download="contrattoNoleggio.pdf"
                  class="btn-info-rental">SCARICA CONDIZIONI DI NOLEGGIO</b-button>

      </b-col>

      <b-col class="container-box-elements" cols="12" md="6">
        <simple-svg
            :src="getImage('noleggio')"
            width="100%"
            height="100%"
            custom-class-name="icon-gray"
        />
      </b-col>
    </b-row>

    <br>

    <div class="content-left">
      <h2>Noleggio</h2>
      <h1>Il noleggio più completo di Varese e provincia</h1>
      <p>Il nostro magazzino è il punto di riferimento per chi cerca attrezzatura invernale nell'area di
        Varese. Lavoriamo tutto l'anno per offrire il parco noleggio più ampio e curato del territorio:
        sci alpini, snowboard e ciaspole, declinati in ogni misura e livello di difficoltà, pensati sia
        per adulti che per bambini.<br>
        Non ci limitiamo a mettere a disposizione quello che abbiamo: ogni anno investiamo
        nell'acquisto di materiale nuovo, dagli sci agli scarponi, dai caschi ai bastoni. Questo
        significa che scegliendo noi avrai sempre tra le mani attrezzatura moderna, performante e
        in perfetto stato.
      </p>
    </div>

    <div class="content-right">
      <h2>Noleggio</h2>
      <h1>Per ogni sciatore, l'attrezzatura giusta</h1>
      <p>Che tu sia un principiante o un esperto, da noi trovi quello che fa per te:</p>
      <ul>
        <li>Principianti e bambini — Sci facili da manovrare, scarponi comodi, caschi certificati
          e leggeri. Tutto pensato per mettere a proprio agio chi sta imparando.</li>
        <li>Sciatori intermedi e avanzati — Sci da carving, all-mountain, scarponi
          con flex progressivo, attrezzatura da snowboard per ogni stile di freeride.</li>
        <li>Chi ama la montagna slow — Ciaspole per escursioni nella neve, perfette per chi
          vuole esplorare boschi e sentieri invernali senza rinunciare alla sicurezza.</li>
      </ul>
    </div>

    <div class="content-left">
      <h2>Noleggio</h2>
      <h1>Igiene e sicurezza: un impegno concreto</h1>
      <p>Ogni volta che ritiri la tua attrezzatura da Due Elle Sport, puoi essere certo di quello che
        stai indossando. Gli sci vengono consegnati sciolinati e laminati, pronti per affrontare
        qualsiasi tipo di neve. Scarponi e caschi vengono lavati e disinfettati dopo ogni utilizzo,
        perché l'igiene non è un optional — è un rispetto che dobbiamo a te e alla tua famiglia.
      </p>
    </div>

    <div class="content-right">
      <h2>Noleggio</h2>
      <h1>Conveniente davvero — non solo a parole</h1>
      <p>Noleggiare da noi è una scelta economica intelligente. Acquistare attrezzatura da sci di
        qualità richiede un investimento importante, spesso giustificato solo se si scia
        regolarmente per molte stagioni. Il noleggio ti permette di:</p>
      <ul>
        <li>Accedere a materiale di alto livello senza spendere migliaia di euro</li>
        <li>Adattare l'attrezzatura alla tua crescita — perfetto per i bambini che cambiano taglia
          ogni anno</li>
        <li>Provare diversi sci senza impegnarti in un acquisto.</li>
      </ul>
    </div>

    <div class="content-left">
      <h2>Noleggio</h2>
      <h1>Vieni a trovarci</h1>
      <p>Il nostro staff è a tua disposizione per consigliarti la soluzione più adatta alle tue esigenze,
        al tuo livello e alla destinazione che hai scelto. Che tu debba partire il giorno dopo o voglia
        prenotare per il weekend, siamo qui per farti trovare tutto pronto.
      </p>
    </div>

  </b-container>
</template>

<script>
export default {
  name: "noleggio-page",
  methods: {
    getImage: function (icon) {
      return require('../assets/img/' + icon + '.svg')
    },
    downloadContract: function () {

    }
  }
}
</script>

<style lang="less">
@import '@/assets/styles/main.less';
@import '@/assets/styles/font.less';

#detail-page {
  margin: 10%;
}

.content-left, .content-right {
  ul {
    margin-top: 1rem;
    .set-font(@color: @text);
    max-width: 75%;
    list-style: none;
    padding-left: 0;
  }
}

.content-right ul {
  margin-left: auto;
}
</style>
